import { NotFound, ProtectedRoute } from "@fdoh/health-ui-react";
import { Redirect, Route, Switch, useRouteMatch } from "react-router-dom";
import CreateAdditionalInformationPage from "./CreateAdditionalInformationForm";
import EditAdditionalInformationPage from "./EditAdditionalInformationForm";

export const CreateAdditionalInformationModule = () => {
  let { path } = useRouteMatch();
  return (
    
      <Switch>
        <ProtectedRoute exact path={path}>
              <CreateAdditionalInformationPage />
        </ProtectedRoute> 
        <ProtectedRoute exact path={`${path}/:id(\\d+)`}>
          <EditAdditionalInformationPage />
        </ProtectedRoute>
        <Route>
          <NotFound />
        </Route>
      </Switch>
    
  );
};

export default CreateAdditionalInformationModule;
